import { useEffect } from 'react';

export const useBodyLock = (shouldLock?: boolean): void => {
  useEffect(() => {
    if (shouldLock !== true) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [shouldLock]);
};